import { useState } from "react";

/** Loads Google Maps only after opt-in — avoids third-party cookies on initial page load. */
export default function ContactMap({
	title,
	src,
	openUrl,
	loadLabel,
	openLabel,
}) {
	const [loaded, setLoaded] = useState(false);

	if (loaded) {
		return (
			<div className="tu-contact__map-embed">
				<iframe
					title={title}
					className="tu-contact__map-frame"
					src={src}
					loading="lazy"
					referrerPolicy="no-referrer-when-downgrade"
					allowFullScreen
				/>
			</div>
		);
	}

	return (
		<div className="tu-contact__map-facade">
			<p className="tu-contact__map-facade-text">{title}</p>
			<div className="tu-contact__map-facade-actions">
				<button
					type="button"
					className="tu-btn tu-btn-primary"
					onClick={() => setLoaded(true)}
				>
					{loadLabel}
				</button>
				<a
					href={openUrl}
					className="tu-btn tu-btn-outline"
					target="_blank"
					rel="noopener noreferrer"
				>
					{openLabel}
				</a>
			</div>
		</div>
	);
}
